class Month {
    constructor(month, monthName, year) {
        this.monthNumber = month;
        this.monthName = monthName;
        this.year = year;
        this.weeks = null;

        this.setWeeks(month, year);
    }
    firstRow(day, month, year) {
        const date = new Date(year, month, day, 0, 0, 0);
        const numberDay = date.getDay();
        let dayNow = 1;
        let days = "";
        for (let i = 0; i < 7; i++) {
            if (i < numberDay) {
                days += ',';
            } else {
                days += (i != 6) ? dayNow + ',' : dayNow;
                dayNow++;
            }
        }
        return days;
    }
    daysInMonth(month, year) {
        const date = new Date(year, month, 1);
        const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        return lastDay.getDate();
    }
    lastDayofWeek(day, month, year) {
        const date = new Date(year, month, day);
        const dayWeek = date.getDay();
        if (dayWeek !== 6) {
            const diff = 6 - dayWeek;
            date.setDate(date.getDate() + diff);
        }
        return date.getDate();
    }
    setCalendar(day, month, year) {
        const dayNow = this.lastDayofWeek(day, month, year);
        const lastDay = this.daysInMonth(month, year);
        let days = "";
        for (let i = (dayNow + 1); i < (lastDay + 1); i++) {
            days += i;
            if (i < lastDay) days += ',';
        }
        const date = new Date(year, month, lastDay, 0, 0, 0);
        const weekDay = date.getDay();
        if (weekDay < 6) {
            const diff = 6 - weekDay;
            for (let i = 0; i < diff; i++) {
                days += ',';
            }
        }
        return days;
    }
    setWeeks(month, year) {
        const firstRow = this.firstRow(1, month, year).split(',');
        const lastDays = this.setCalendar(1, month, year).split(',');
        const array = [
            ...firstRow,
            ...lastDays
        ];
        let weekNumber = 0;        
        let weeksArray = [];
        let counter = 0;
        while (counter < array.length) {            
            weeksArray.push(array.slice(counter, counter + 7));
            weekNumber += 1;
            counter += 7;
        }
        this.weeks = weeksArray;
    }
}
export default Month;